{
	"tradeSideToggle": {
		"buy": "Buy",
		"sell": "Sell"
	}
}
